import { Bars3Icon } from '@heroicons/react/24/outline'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { AuthContext } from '../context/auth-context'

export default function MobileHeader({ setSidebarOpen }) {
  const { t } = useTranslation()
  const { user, logout } = useContext(AuthContext)

  return (
    <div className="sticky top-0 z-40 flex items-center gap-x-6 bg-indigo-800 px-4 py-4 shadow-xs after:pointer-events-none after:absolute after:inset-x-0 after:bottom-0 after:h-px after:bg-white/10 sm:px-6 lg:hidden">
      <button
        type="button"
        onClick={() => setSidebarOpen(true)}
        className="-m-2.5 p-2.5 text-indigo-200 hover:text-white lg:hidden"
      >
        <Bars3Icon aria-hidden="true" className="size-6" />
      </button>
      <div className="flex-1 text-sm/6 font-semibold text-white">{t('sidebar.mobileHeader.title')}</div>
    </div>
  )
}
